import React, { useMemo, useState } from "react";
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Container,
  Typography,
  Button,
  Stack,
} from '@mui/material';
import AppleIcon from '@mui/icons-material/Apple';
// feature icons removed — editorial for these features was deleted
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CelebrationIcon from '@mui/icons-material/Celebration';

const IosAppPage = () => {
    const COLORS = useMemo(() => ({
        logoBackground: '#FFD1A3',
        camera: '#2E3434',
        coral: '#FF6B6B',
        orange: '#FF9F43',
        teal: '#00C2A8',
        purple: '#7B61FF',
        sunshine: '#FFD166',
        cream: '#FFF8F2',
        navy: '#14202B',
        gold: '#D4AF37'
    }), []);

    const APP_STORE_URL = 'https://apps.apple.com/app/monadx/id6756245698';

    const [comingSoon] = useState(false);

    return (
        <Box sx={{ bgcolor: COLORS.cream, minHeight: '100vh' }}>
          <Helmet>
            <title>MonadX for iOS — MonadX</title>
            <meta name="description" content="MonadX for iOS — download on the App Store to turn photos into recipes." />
            <meta property="og:title" content="MonadX for iOS" />
          </Helmet>
          <Box sx={{ py: { xs: 6, md: 10 }, background: `linear-gradient(135deg, ${COLORS.coral}, ${COLORS.purple}, ${COLORS.sunshine})`, color: '#fff' }}>
            <Container maxWidth="md">
              <Box textAlign="center" mb={4}>
                <AppleIcon sx={{ fontSize: 48 }} />
                <Typography variant="h2" fontWeight={900} sx={{ mt: 1 }}>MonadX for iOS</Typography>
                <Typography variant="h6" fontWeight={700} sx={{ opacity: 0.95, mt: 1 }}>Manage DM campaigns and monitor performance on the go.</Typography>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center" mt={3}>
                  <Button
                    component={comingSoon ? 'button' : 'a'}
                    href={comingSoon ? undefined : APP_STORE_URL}
                    target={comingSoon ? undefined : '_blank'}
                    rel={comingSoon ? undefined : 'noopener noreferrer'}
                    variant="contained"
                    size="large"
                    disabled={comingSoon}
                    startIcon={<AccessTimeIcon />}
                    sx={{ bgcolor: '#ffffff', color: COLORS.coral, fontWeight: 700, '&:hover': { bgcolor: '#fff' } }}
                    aria-label={comingSoon ? 'Coming soon on the App Store' : 'Open MonadX on the App Store'}
                  >
                        {comingSoon ? 'Coming Soon to the App Store' : 'Open in App'}
                  </Button>

                  {/* Waitlist button removed per request */}
                </Stack>
              </Box>
            </Container>
          </Box>

          <Container sx={{ py: { xs: 4, md: 8 } }}>
            <Typography variant="h4" align="center" fontWeight={800} sx={{ color: COLORS.navy, mb: 4 }}>Built for iPhone & iPad — manage campaigns anywhere</Typography>

            {/* Feature cards removed per editorial request */}

            <Box textAlign="center" mt={6}>
              <CelebrationIcon sx={{ fontSize: 44, color: COLORS.coral }} />
              <Typography variant="h5" fontWeight={800} sx={{ color: COLORS.navy, mt: 2 }}>Campaigns, analytics, and subscriber management — in your pocket</Typography>
              <Typography variant="body1" sx={{ color: COLORS.navy, opacity: 0.85, mt: 1, mb: 2 }}>MonadX for iOS lets you create opt-in funnels, send scheduled DMs, and review engagement metrics from anywhere.</Typography>
            </Box>
          </Container>
        </Box>
    )
}

export default IosAppPage;